import Footer from "./Footer";
import Header from "./Header";
import { mainContentColor } from "./lib/Color";
import Container from "@material-ui/core/Container";

const Layout: React.FC = ({ children }) => {
  return (
    <>
      {/* TODO 一旦ここで高さを設定あとで変更するかも */}
      <Container
        disableGutters
        maxWidth="xl"
        style={{ backgroundColor: mainContentColor, height: "100vh" }}
      >
        <Header />
        {children || <></>}
        <Footer />
      </Container>
    </>
  );
};

export default Layout;
